import { Menu } from '@mantine/core';
import { Icon, SymbolCodepoints } from '@uag/react-core';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const EditGroup = () => {
    const { t } = useTranslation();

    const { articleInstanceSelections, instanceToGroupMap, openEditGroupPanel } = usePlacementStore(
        useShallow((state) => ({
            articleInstanceSelections: state.articleInstanceSelections,
            instanceToGroupMap: state.instanceToGroupMap,
            openEditGroupPanel: state.openEditGroupPanel
        }))
    );

    const selectedInstanceIds = useMemo(() => Object.keys(articleInstanceSelections), [articleInstanceSelections]);

    // Resolve groupId
    const singleGroupId = useMemo<string | null>(() => {
        if (selectedInstanceIds.length === 0) {
            return null;
        }

        const groupIds = selectedInstanceIds.map((id) => instanceToGroupMap[id]);
        if (groupIds.some((gid) => gid == null)) {
            return null;
        }

        const unique = new Set(groupIds);
        if (unique.size !== 1) {
            return null;
        }

        return groupIds[0];
    }, [selectedInstanceIds, instanceToGroupMap]);

    const handleClick = useCallback(() => {
        if (singleGroupId) {
            openEditGroupPanel(singleGroupId);
        }
    }, [singleGroupId, openEditGroupPanel]);

    if (singleGroupId == null) {
        return null;
    }

    return (
        <Menu.Item
            leftSection={
                <Icon
                    className="action-menu-entry-decoration action-menu-entry-decoration-icon"
                    icon={'edit' as SymbolCodepoints}
                />
            }
            onClick={handleClick}
        >
            {t('labelEditGroup')}
        </Menu.Item>
    );
};
